import initSelectCustom from "../parts/custom-select";

const createSelectByCountry = (
    cities = [],
    _selectWrap = null,
    city_id = null
) => {
    const _oldSelect = _selectWrap.querySelector(".select");

    if (_oldSelect) {
        _oldSelect.remove();
    }

    if (cities.length) {
        const _selectNode = document.createElement("select");
        _selectNode.id = "city_id";
        _selectNode.name = "city_id";

        cities.forEach((city) => {
            const _optionNode = document.createElement("option");
            _optionNode.value = city.id;
            _optionNode.text = city.name;

            if (city_id == city.id) {
                _optionNode.setAttribute("selected", true);
            }

            _selectNode.appendChild(_optionNode);
        });
        _selectWrap.querySelector("label").classList.remove("hide");
        _selectWrap.appendChild(_selectNode);

        initSelectCustom(_selectNode);

        return _selectNode;
    }
};

export default createSelectByCountry;
